module.exports = __webpack_public_path__ + "static/media/pasamosagostomini.106b3fb6.jpg";